import type { TrackingSpecs } from '@/libraries/tracking';
import { createSpecTracker } from '@/libraries/tracking';
const specs = {
	buffering: {
		category: 'youtube_buffering',
		nonInteraction: true,
	},
	playing: {
		category: 'youtube_playing',
		nonInteraction: true,
	},
	errored: {
		category: 'youtube_errored',
		nonInteraction: true,
	},
} satisfies TrackingSpecs;
export function useBackgroundVideoTracking(baseProperties: { value: number; action: string; label: string }) {
	const track = createSpecTracker({ specs, baseProperties });
	return { trackBackgroundVideo: track };
}
